const js_toggles = document.querySelectorAll('.js-toggle');

js_toggles.forEach(item => {
  item.addEventListener('click', (e) => {
    e.preventDefault();
    const target = document.getElementById(e.target.getAttribute('data-item'));

    if (target) {
      if (!target.classList.contains('active')) {
        target.classList.add('active');
        target.style.height = 'auto';
        const height = target.clientHeight + 'px';
        target.style.height = '0';

        requestAnimationFrame(() => {
          target.style.height = height;
        });
      } else {
        target.style.height = '0';
        target.addEventListener('transitionend', () => {
          target.classList.remove('active');
        }, {
          once: true
        });
      }
    }

  })
})